// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_RECENT_POSTS = "Najnov\u0161ie ot\u00e1zky z poradne";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskusie";
export const PREGNANCY_NEWSLETTER = "Tehotensk\u00fd newsletter";
export const PREGNANCY_NEWSLETTER_DESCRIPTION = "Ka\u017ed\u00fd t\u00fd\u017ede\u0148 dostane\u0161 najd\u00f4le\u017eitej\u0161ie info do e-mailu";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR = "Tehotenskej kalkula\u010dke";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_01 = "Nepozn\u00e1\u0161 t\u00fd\u017ede\u0148 tehotenstva? Vypo\u010d\u00edtaj si ho v";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH = "Tehotenskej kalkula\u010dke";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH_01 = "Nepozn\u00e1\u0161 term\u00edn p\u00f4rodu? Vypo\u010d\u00edtaj si ho v";
export const PREGNANCY_WEEKS_BOX_01 = "Zisti viac o svojom tehotenstve:";
export const PREGNANCY_WEEKS_BOX_02 = "Tehotenstvo t\u00fd\u017ede\u0148 po t\u00fd\u017edni";
export const RELATED_DISCUSSIONS_IN_FORUM = "S\u00favisiace diskusie";
export const YOUTUBE_MK_TITLE = "YouTube Modr\u00fd kon\u00edk";
